<template>
	<view class="box">
		<view class="box-info">
			<view class="shop">
				<view class="shop-image">
					<image  v-if="shop.imgurl"  @click="previewImage(shop.imgurl)" :src="shop.imgurl" mode="widthFix"></image>
				</view>
				<view class="shop-info">
					<text>{{shop.name || ''}}</text>
					<text>联系人：{{shop.realname || ''}}</text>
					<text>联系电话：{{shop.phone || ''}}</text>
				</view>
			</view>
			<view class="xian"></view>
			<view class="info">
				<view class="info-item">
					<view class="info-item-label">营业时间：</view>
					<view class="info-item-val">周一至周五 {{shop.startTime || ''}}</view>
				</view>
				<view class="info-item">
					<view class="info-item-label">省市区：</view>
					<view class="info-item-val">{{(shop.areas.provinceName||'') + (shop.areas.cityName||'') + (shop.areas.name||'')}}</view>
				</view>
				<view class="info-item">
					<view class="info-item-label">门店地址：</view>
					<view class="info-item-val">{{shop.addr || ''}}</view>
				</view>
				<view class="info-item">
					<view class="info-item-label">营业执照：</view>
					<view class="info-item-image">
						<image v-if="shop.businessImg"  @click="previewImage(shop.businessImg)" :src="shop.businessImg" mode="widthFix"></image>
					</view>
				</view>
			</view>
		</view>
		<view class="box-info">
			<view class="user-title">法人信息</view>
			<view class="info">
				<view class="info-item">
					<view class="info-item-label">法人姓名：</view>
					<view class="info-item-val">{{shop.legalPersonName || ''}}</view>
				</view>
				<view class="info-item">
					<view class="info-item-label">法人电话：</view>
					<view class="info-item-val">{{shop.legalPersonPhone||''}}</view>
				</view>
				<view class="info-item">
					<view class="info-item-label">身份证：</view>
					<view class="info-item-list">
						<view class="info-item-list-image"  v-if="shop.idcardImg" >
							<image :src="shop.idcardImg" mode="widthFix" @click="previewImage(shop.idcardImg)"></image>
						</view>
						<view class="info-item-list-image"  v-if="shop.idcardImgBack">
							<image :src="shop.idcardImgBack"  @click="previewImage(shop.idcardImgBack)" mode="widthFix"></image>
						</view>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	import { mapState } from 'vuex' 
	export default {
		computed: {
			...mapState(['navHeight', 'statusbarHeight','shopInfo', 'shopToken'])
		},
		data() {
			return {
				shop:{}
			};
		},
		onShow() {
			this.shop  ={}
			this.checkShopLogin()
			this.shop = this.shopInfo || {}
		},
		methods:{
			previewImage (url)  {
				if (url) {
					uni.previewImage({
						urls:[url]
					})
				}
			},
			async  checkShopLogin(){
				var that =this
				if( this.shopInfo ==null || this.shopInfo.id==null ||  this.shopToken==null || this.shopToken==''){
					uni.navigateTo({
						url: '/pages/login/login'
					})
				} 
				let res = await that.$u.api.getShopInfo({tokenType:1  })
				if (res.code === 200) {
					that.shop = res.data
				}
			} 
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.box-info {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			display: flex;
			flex-direction: column;
			margin-bottom: 20rpx;
			.user-title {
				font-weight: 600;
				font-size: 32rpx;
				color: #111111;
				margin-bottom: 30rpx;
			}
			.info-item-list {
				width: 100%;
				display: flex;
				align-items: center;
				.info-item-list-image {
					width: 200rpx;
					height: 150rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					overflow: hidden;
					border-radius: 8rpx;
					border: 1rpx solid #E5E5E5;
					margin-right: 20rpx;
					image {
						width: 100%;
					}
				}
			}
			.shop {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.shop-image {
					flex-shrink: 0;
					width: 144rpx;
					margin-right: 24rpx;
					height: 144rpx;
					border-radius: 8rpx;
					overflow: hidden;
					image {
						width: 100%;
					}
				}
				.shop-info {
					flex: 1;
					height: 144rpx;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					text {
						&:nth-child(1) {
							font-weight: 500;
							font-size: 32rpx;
							color: #111111;
						}
						&:nth-child(2) {
							font-weight: 400;
							font-size: 26rpx;
							color: #777777;
						}
						&:nth-child(3) {
							font-weight: 400;
							font-size: 26rpx;
							color: #777777;
						}
					}
				}
			}
			.xian {
				width: 100%;
				height: 1rpx;
				margin: 30rpx 0;
				background-color: #E5E5E5;
			}
			.info {
				width: 100%;
				display: flex;
				flex-direction: column;
				.info-item {
					width: 100%;
					display: flex;
					align-items: flex-start;
					margin-bottom: 20rpx;
					.info-item-label {
						width: 130rpx;
						flex-shrink: 0;
						font-weight: 400;
						font-size: 26rpx;
						color: #777777;
					}
					.info-item-val {
						flex: 1;
						font-weight: 400;
						font-size: 26rpx;
						color: #333333;
					}
					.info-item-image {
						width: 200rpx;
						height: 150rpx;
						border-radius: 8rpx;
						overflow: hidden;
						display: flex;
						align-items: center;
						justify-content: center;
						border: 1rpx solid #E5E5E5;
						image {
							width: 100%;
						}
					}
				}
			}
		}
	}
</style>